<avi-card class="system-report-summary-card">
    <avi-card_header>
        <div class="system-report-summary-card__header-wrapper">
            <cds-icon
                shape="clipboard"
                size="20"
                status="success"
                class="system-report-summary-card__header-wrapper-icon"
            ></cds-icon>
            {{ globalL10nKeys.summaryLabel | vtranslate }}
        </div>
    </avi-card_header>
    <avi-card_body>
        <div
            class="system-report-summary-card__loader"
            *ngIf="isLoading; else summaryDetails"
        >
            <clr-spinner [clrSmall]="true"></clr-spinner>
        </div>

        <ng-template #summaryDetails>
            <div class="system-report-summary-card__content-header">
                <div class="system-report-summary-card__content-header-wrapper">
                    <div class="system-report-summary-card__content-title">
                        {{ globalL10nKeys.nameLabel | vtranslate }}
                    </div>
                    <div class="system-report-summary-card__content-sub-title">
                        {{ systemReportName }}
                    </div>
                </div>
                <div class="system-report-summary-card__content-header-title-wrapper">
                    <div class="system-report-summary-card__content-title">
                        {{ l10nKeys.startAndEndTimeLabel | vtranslate }}
                    </div>
                    <div class="system-report-summary-card__content-sub-title">
                        {{ systemReportStartAndEndTime.startTime | aviDate }}
                        -
                        {{ systemReportStartAndEndTime.endTime | aviDate }}
                    </div>
                </div>
            </div>
            <div class="system-report-summary-card__progress-wrapper">
                <div class="system-report-summary-card__statistics-wrapper">
                    <div class="system-report-summary-card__statistics-legend">
                        <cds-icon
                            shape="exclamation-circle"
                            size="22"
                            [class]="'system-report-summary-card__statistics-legend-' + progressClass.error"
                        ></cds-icon>
                        <span>{{ l10nKeys.errorsLabel | vtranslate }}</span>
                    </div>

                    <div class="system-report-summary-card__statistics-legend">
                        <cds-icon
                            shape="exclamation-triangle"
                            size="22"
                            [class]="'system-report-summary-card__statistics-legend-' + progressClass.warning"
                        ></cds-icon>
                        <span>{{ l10nKeys.warningsLabel | vtranslate }}</span>
                    </div>

                    <div class="system-report-summary-card__statistics-legend">
                        <cds-icon
                            shape="check-circle"
                            size="22"
                            [class]="'system-report-summary-card__statistics-legend-' + progressClass.success"
                        ></cds-icon>
                        <span>{{ l10nKeys.successLabel | vtranslate }}</span>
                    </div>
                </div>
                <div
                    class="system-report-summary-card__statistics-wrapper"
                    *ngrxLet="systemReadinessSummaryDetails"
                >
                    <div class="system-report-summary-card__statistics-title-wrapper">
                        <span
                            class="system-report-summary-card__statistics-title-wrapper-title"
                            [aviTitle]="l10nKeys.systemReadinessLabel | vtranslate"
                        >
                            {{ l10nKeys.systemReadinessLabel | vtranslate }}
                        </span>
                    </div>
                    <system-report-summary-card-progress-bar
                        [value]="systemReadinessSummaryDetails.errors"
                        [maxValue]="systemReadinessSummaryDetails.maxProgressBarValue"
                        [iconColorClass]="progressClass.error"
                    ></system-report-summary-card-progress-bar>
                    <system-report-summary-card-progress-bar
                        [value]="systemReadinessSummaryDetails.warnings"
                        [maxValue]="systemReadinessSummaryDetails.maxProgressBarValue"
                        [iconColorClass]="progressClass.warning"
                    ></system-report-summary-card-progress-bar>
                    <system-report-summary-card-progress-bar
                        [value]="systemReadinessSummaryDetails.success"
                        [maxValue]="systemReadinessSummaryDetails.maxProgressBarValue"
                        [iconColorClass]="progressClass.success"
                    ></system-report-summary-card-progress-bar>
                </div>
                <ng-container *ngrxLet="dryRunSummaryDetails">
                    <div
                        class="system-report-summary-card__statistics-wrapper"
                        *ngIf="dryRunSummaryDetails"
                    >
                        <div class="system-report-summary-card__statistics-title-wrapper">
                            <span
                                class="system-report-summary-card__statistics-title-wrapper-title"
                                [aviTitle]="l10nKeys.dryRunLabel | vtranslate"
                            >
                                {{ l10nKeys.dryRunLabel | vtranslate }}
                            </span>
                        </div>
                        <system-report-summary-card-progress-bar
                            [value]="dryRunSummaryDetails.errors"
                            [maxValue]="dryRunSummaryDetails.maxProgressBarValue"
                            [iconColorClass]="progressClass.error"
                        ></system-report-summary-card-progress-bar>
                        <system-report-summary-card-progress-bar
                            [value]="dryRunSummaryDetails.warnings"
                            [maxValue]="dryRunSummaryDetails.maxProgressBarValue"
                            [iconColorClass]="progressClass.warning"
                        ></system-report-summary-card-progress-bar>
                        <system-report-summary-card-progress-bar
                            [value]="dryRunSummaryDetails.success"
                            [maxValue]="dryRunSummaryDetails.maxProgressBarValue"
                            [iconColorClass]="progressClass.success"
                        ></system-report-summary-card-progress-bar>
                    </div>
                </ng-container>
                <div
                    class="system-report-summary-card__statistics-wrapper"
                    *ngrxLet="systemTaskDetails"
                >
                    <div class="system-report-summary-card__statistics-title-wrapper">
                        <span
                            class="system-report-summary-card__statistics-title-wrapper-title"
                            [aviTitle]="l10nKeys.systemTaskLabel | vtranslate"
                        >
                            {{ l10nKeys.systemTaskLabel | vtranslate }}
                        </span>
                    </div>
                    <system-report-summary-card-progress-bar
                        [value]="systemTaskDetails.errors"
                        [maxValue]="systemTaskDetails.maxProgressBarValue"
                        [iconColorClass]="progressClass.error"
                    ></system-report-summary-card-progress-bar>
                    <system-report-summary-card-progress-bar
                        [value]="systemTaskDetails.warnings"
                        [maxValue]="systemTaskDetails.maxProgressBarValue"
                        [iconColorClass]="progressClass.warning"
                    ></system-report-summary-card-progress-bar>
                    <system-report-summary-card-progress-bar
                        [value]="systemTaskDetails.success"
                        [maxValue]="systemTaskDetails.maxProgressBarValue"
                        [iconColorClass]="progressClass.success"
                    ></system-report-summary-card-progress-bar>
                </div>
                <div class="system-report-summary-card__statistics-wrapper">
                    <span class="system-report-summary-card__statistics-title-wrapper-title">
                        {{ globalL10nKeys.totalTimeLabel | vtranslate }}
                    </span>

                    <span class="system-report-summary-card__statistics-wrapper-duration">
                        {{ totalProcessTime | secondToMs }}{{ globalL10nKeys.msLabel | vtranslate }}
                    </span>

                    <div class="system-report-summary-card__summary-container">
                        <div class="system-report-summary-card__summary-container-header">
                            <cds-icon
                                shape="circle"
                                size="14"
                                class="system-report-summary-card__system-readiness-icon"
                                solid
                            ></cds-icon>
                            <div
                                class="system-report-summary-card__summary-container-header-title"
                                [aviTitle]="l10nKeys.systemReadinessLabel | vtranslate"
                            >
                                {{ l10nKeys.systemReadinessLabel | vtranslate }}
                            </div>
                        </div>
                        <span>
                            {{ systemReadinessSummaryDetails.totalTime | secondToMs }}
                            {{ globalL10nKeys.msLabel | vtranslate }}
                        </span>
                    </div>

                    <div
                        class="system-report-summary-card__summary-container"
                        *ngIf="dryRunSummaryDetails"
                    >
                        <div class="system-report-summary-card__summary-container-header">
                            <cds-icon
                                shape="circle"
                                size="14"
                                class="system-report-summary-card__dry-run-icon"
                                solid
                            ></cds-icon>
                            <div
                                class="system-report-summary-card__summary-container-header-title"
                                [aviTitle]="l10nKeys.dryRunLabel | vtranslate"
                            >
                                {{ l10nKeys.dryRunLabel | vtranslate }}
                            </div>
                        </div>
                        <span>
                            {{ dryRunSummaryDetails.totalTime | secondToMs }}
                            {{ globalL10nKeys.msLabel | vtranslate }}
                        </span>
                    </div>

                    <div class="system-report-summary-card__summary-container">
                        <div class="system-report-summary-card__summary-container-header">
                            <cds-icon
                                shape="circle"
                                size="14"
                                class="system-report-summary-card__system-task-icon"
                                solid
                            ></cds-icon>
                            <div
                                class="system-report-summary-card__summary-container-header-title"
                                [aviTitle]="l10nKeys.systemTaskLabel | vtranslate"
                            >
                                {{ l10nKeys.systemTaskLabel | vtranslate }}
                            </div>
                        </div>
                        <span>
                            {{ systemTaskDetails.totalTime | secondToMs }}
                            {{ globalL10nKeys.msLabel | vtranslate }}
                        </span>
                    </div>
                </div>
            </div>
        </ng-template>
    </avi-card_body>
</avi-card>
